import React, {Component} from 'react';
import axios from 'axios'

class Reset extends React.Component {
	constructor () {
		super();
		this.state = {
			active: false,
			resetError: false,
			resetSent: false,
			email: ''
		};
	}

	handleChange = (event) =>{
		this.setState({ 'email': event.target.value, active: true } );
	}

	handleSubmit = (event) =>{
		event.preventDefault();

		this.setState({
			resetError: false,
			active: false,
			resetSent: false
		});

		axios.post( '/users/reset.json', {
			'password_reset': {
				'email': this.state.email
			},
			authenticity_token: this.props.token
		}).then(response => {
			this.setState({
				resetError: false,
				email: '',
				active: true,
				resetSent: true
			});
		}).catch(err => {
			this.setState({
				active: true,
				resetSent: false,
				resetError: err.response.data.message ? err.response.data.message : 'Sorry an error has occured'
			});
		});
	}

	render() {
		return (

			<form action="/users/reset.json" autoComplete="off" acceptCharset="UTF-8" method="post">

				{this.state.resetError
					? <div className="callout danger">
						Sorry password reset request has failed
						<br />{this.state.resetError}
					</div>
					: null
				}

				{this.state.resetSent
					? (
						<div className="callout success">
							Email sent with password reset instuctions
							<div className="account-help">
						  		<div className="panel-footer-inline text-center">
							  		<a onClick={this.props.handleViewChange.bind(null, 'login')}>Back to login</a>
						  		</div>
							</div>
						</div>
					) : (
						<div>
							<div className="backBtn"><span className="icon icon-left"></span><a onClick={this.props.handleViewChange.bind(null, 'login')}>Back</a></div>
							<p>Enter the email address associated with your account, and we’ll email you a link to reset your password.</p>
							<input value={this.state.email} onChange={this.handleChange} className="input-group-field" placeholder="Enter your email address" type="email" name="password_reset[email]" id="password_reset_email" />

							<input onClick={this.handleSubmit} disabled={!this.state.active} type="button" name="commit" value="Submit" className="button primary expanded" />

						</div>
					)
				}



			</form>
		)
	}
}
export default Reset
